import { useTranslation } from 'react-i18next';
import { Wordmark } from './Wordmark';
import Icon from './Icon';

function FooterCol({ title, items }) {
  return (
    <div>
      <div className="mono" style={{
        fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase',
        color: 'var(--p2a-dark-fg-4)', marginBottom: 16,
      }}>{title}</div>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {items.map((it, i) => (
          <li key={i} style={{ marginBottom: 10 }}>
            {it.href ? (
              <a
                href={it.href}
                style={{ fontSize: 13.5, color: 'var(--p2a-dark-fg-2)', transition: 'color var(--p2a-dur-base) var(--p2a-ease)' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--p2a-green-400)')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--p2a-dark-fg-2)')}
              >
                {it.label}
              </a>
            ) : (
              <span style={{ fontSize: 13.5, color: 'var(--p2a-dark-fg-2)' }}>{it.label}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  const { t } = useTranslation();
  const socials = [
    { icon: 'Linkedin',  href: 'https://linkedin.com/company/pix2agro', label: 'LinkedIn' },
    { icon: 'Instagram', href: 'https://instagram.com/pix2agro',        label: 'Instagram' },
    { icon: 'Youtube',   href: 'https://youtube.com/@pix2agro902',      label: 'YouTube' },
    { icon: 'Whatsapp',  href: 'https://wa.me/5519996542014',           label: 'WhatsApp' },
  ];

  return (
    <footer style={{
      borderTop: '1px solid var(--p2a-dark-border)',
      background: 'var(--p2a-dark-bg)',
      padding: '64px 0 32px',
      color: 'var(--p2a-dark-fg-3)',
    }}>
      <div className="p2-container">
        <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr 1fr', gap: 48 }} className="footer-grid">
          <div>
            <Wordmark size={28} />
            <p style={{ marginTop: 20, fontSize: 13.5, maxWidth: 320, color: 'var(--p2a-dark-fg-3)' }}>
              {t('footer.tagline')}
            </p>
            <div style={{ display: 'flex', gap: 8, marginTop: 24 }}>
              {socials.map((s) => {
                const I = Icon[s.icon];
                return (
                  <a
                    key={s.icon}
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    style={{
                      width: 36, height: 36, borderRadius: 4,
                      border: '1px solid var(--p2a-dark-border-2)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: 'var(--p2a-dark-fg-2)',
                      transition: 'color var(--p2a-dur-base) var(--p2a-ease), border-color var(--p2a-dur-base) var(--p2a-ease)',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--p2a-green-400)'; e.currentTarget.style.borderColor = 'var(--p2a-green-500)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--p2a-dark-fg-2)'; e.currentTarget.style.borderColor = 'var(--p2a-dark-border-2)'; }}
                  >
                    <I width={15} height={15} />
                  </a>
                );
              })}
            </div>
          </div>

          <FooterCol
            title={t('footer.company_title')}
            items={[
              { label: t('footer.about_us'), href: '#sobre' },
              { label: t('footer.clients'),  href: '#clientes' },
              { label: t('footer.contact'),  href: '#contato' },
            ]}
          />
          <FooterCol
            title={t('footer.contact_title')}
            items={[
              { label: 'comercial@pix2agro.com', href: 'mailto:comercial@pix2agro.com' },
              { label: '+55 19 99654-2014', href: 'https://wa.me/5519996542014' },
              { label: t('footer.location'), href: null },
            ]}
          />
        </div>

        <div style={{
          marginTop: 64, paddingTop: 24,
          borderTop: '1px solid var(--p2a-dark-border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          gap: 16, flexWrap: 'wrap',
        }}>
          <div className="mono" style={{ fontSize: 11, color: 'var(--p2a-dark-fg-4)', letterSpacing: '0.08em' }}>
            {t('footer.rights', { year: new Date().getFullYear() })}
          </div>
          <div className="mono" style={{ fontSize: 11, color: 'var(--p2a-dark-fg-4)', letterSpacing: '0.08em' }}>
            {t('footer.motto')}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 820px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
        }
        @media (max-width: 520px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
